import React from "react";
import Screenshot from "../imgs/gaelicrun.png";

export const GaelicRun = () => {
  return (
    <div className="itemContainer">
      <div className="itemContained">
        <img
          src={Screenshot}
          alt="Gaelic Run"
          className="screenshot"

        />
      </div>
      <div className="itemContained itemExplainer">
        <center>
          <span className="itemTitle">Gaelic Run</span>
          <br />
          <br />

          <span className="itemBody">
            A game to practice the gender, plural or genitive of Gaelic nouns,
            with a retro video-game feel.
          </span>
        </center>
      </div>
    </div>
  );
};
